<template>
    <div class="consultation-record">
        <!-- ConsultationRecord -->

        
        <!-- 数据列表区 -->
		<el-table :data="listData" v-loading="listLoading" border highlight-current-row style="width: 100%;align: center;">

			<!-- <el-table-column prop="id" label="记录ID" align="center" v-if="false">
			</el-table-column> -->
			<el-table-column prop="entityId" label="部门ID" align="center">
			</el-table-column>
			<el-table-column prop="content" label="咨询内容" align="center">
			</el-table-column>
			<el-table-column prop="isAnswerStr" label="是否解答" align="center">
			</el-table-column>
			<el-table-column prop="answerContent" label="解答内容" align="center">
			</el-table-column>
			<el-table-column prop="satisfaction" label="满意度" align="center">
			</el-table-column>
			<el-table-column prop="createTimeStr" label="创建时间"  align="center">
			</el-table-column>
			<el-table-column prop="updateTimeStr" label="修改时间" align="center">
			</el-table-column>
			<el-table-column prop="operator" label="操作" align="center">
				<template v-slot:="{row,$index}">
					<el-button type="danger" size="mini" @click="handleDelete(row)">
						删除
					</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!-- 分页栏 -->
		<pagination :total="totalCounts" @pagination="handlePageChange">
		</pagination>
    </div>
</template>

<script>
import Pagination from '@/components/common/Pagination'
import {consultationList} from '@/api/consultation'
import {formatDate} from '@/utils/date'

export default {
    name: 'ConsultationRecord',
    components: {
        Pagination,
    },
    data(){
        return{
            listLoading: true,
            listData: [],
            totalCounts: 0,
            listQuery: {
                entityId: this.$store.getters['user/entityId'],
                pageIndex: 1,
                pageSize: 10,
                params: {
                    
                },
                fuzzySearch: true
            },
        }
    },
    methods:{
        handleFilter() {
            this.listLoading = true
            consultationList(this.listQuery).then(res => {
                let data = res.pageData
                this.totalCounts = data.totalCounts
                // 对后端数据进行解析
                this.listData = data.datas.map(item => {
                    item.isAnswerStr=(item.isAnswer==0?"是":"否")
                    item.createTimeStr=formatDate(item.createTime)
                    item.updateTimeStr=formatDate(item.updateTime)
                    return item
                })
                this.listLoading = false
            })
        },
        handlePageChange(data) {
            this.listQuery.pageIndex = data.page
            this.listQuery.pageSize = data.limit
            this.handleFilter()
        },
        handleDelete(row){
            console.log('delete\n',row)
        },
    },
    mounted(){
        this.handleFilter()
    }
}
</script>

<style scoped>

</style>